module.exports = __webpack_public_path__ + "static/media/bg-palm.ec64f346.svg";